/** Takım sayfası — hiyerarşi SSOT */

import { PANEL } from "./panelTokens";

export const panelTeamHierarchyScrollSx = {
  maxHeight: 360,
  overflowY: "auto",
  pr: 0.5,
};

export const panelTeamHierarchyBranchSx = {
  ml: 2.5,
  mt: 1,
  pl: 2,
  borderLeft: `2px dashed ${PANEL.accent.softBorder45}`,
};

export const panelTeamHierarchyAvatarSx = (variant = "default") => {
  const map = {
    root: {
      bgcolor: PANEL.blue.soft,
      color: PANEL.blue.text,
      border: `1px solid ${PANEL.blue.soft25}`,
    },
    current: {
      bgcolor: PANEL.accent.soft,
      color: PANEL.accent.text,
      border: `2px solid ${PANEL.accent.softBorder45}`,
    },
    default: {
      bgcolor: PANEL.fill.muted,
      color: PANEL.text.body,
      border: `1px solid ${PANEL.border}`,
    },
  };
  return {
    width: 40,
    height: 40,
    fontWeight: 700,
    fontSize: "0.85rem",
    ...map[variant],
  };
};
